import { useTranslation } from "react-i18next";

export default function TermsOfService() {
  const { t } = useTranslation("legal");

  return (
    <article className="flex flex-col p-4 overflow-auto h-dvh">
      <header>
        <h1 className="mb-4 text-2xl font-bold">{t("termsOfService.title")}</h1>
        <p className="mb-2 text-lg">{t("termsOfService.lastUpdated")}</p>
        <p className="mb-4 text-base">{t("termsOfService.pleaseRead")}</p>
        <p className="mb-4 text-sm text-gray-600">
          {t("termsOfService.byAccessing")}
        </p>
      </header>

      <main>
        <section>
          <h2 className="mb-2 text-xl font-bold">
            {t("termsOfService.mainTitle")}
          </h2>
          <p className="mb-4">
            <strong>Summary:</strong> {t("termsOfService.summary")}
          </p>
          <p className="mb-4">{t("termsOfService.welcome")}</p>
        </section>

        <section>
          <h3 className="mb-2 text-lg font-bold">
            {t("termsOfService.section1.title")}
          </h3>
          <ul className="pl-6 mb-4 list-disc">
            <li>{t("termsOfService.section1.point1")}</li>
            <li>{t("termsOfService.section1.point2")}</li>
            <li>{t("termsOfService.section1.point3")}</li>
          </ul>
        </section>

        <section>
          <h3 className="mb-2 text-lg font-bold">
            {t("termsOfService.section2.title")}
          </h3>
          <ul className="pl-6 mb-4 list-disc">
            <li>{t("termsOfService.section2.point1")}</li>
            <li>{t("termsOfService.section2.point2")}</li>
            <li>{t("termsOfService.section2.point3")}</li>
          </ul>
        </section>

        <section>
          <h3 className="mb-2 text-lg font-bold">
            {t("termsOfService.section3.title")}
          </h3>
          <ul className="pl-6 mb-4 list-disc">
            <li>{t("termsOfService.section3.point1")}</li>
            <li>{t("termsOfService.section3.point2")}</li>
            <li>{t("termsOfService.section3.point3")}</li>
          </ul>
        </section>

        <section>
          <h3 className="mb-2 text-lg font-bold">
            {t("termsOfService.section4.title")}
          </h3>
          <ul className="pl-6 mb-4 list-disc">
            <li>{t("termsOfService.section4.point1")}</li>
            <li>{t("termsOfService.section4.point2")}</li>
          </ul>
        </section>

        <section>
          <h3 className="mb-2 text-lg font-bold">
            {t("termsOfService.section5.title")}
          </h3>
          <ul className="pl-6 mb-4 list-disc">
            <li>{t("termsOfService.section5.point1")}</li>
            <li>
              {t("termsOfService.section5.point2", {
                components: {
                  1: (
                    <a
                      href="https://www.groq.com"
                      className="text-blue-600 hover:underline"
                    />
                  ),
                },
              })}
            </li>
            <li>{t("termsOfService.section5.point3")}</li>
          </ul>
        </section>

        <section>
          <h3 className="mb-2 text-lg font-bold">
            {t("termsOfService.section6.title")}
          </h3>
          <ul className="pl-6 mb-4 list-disc">
            <li>{t("termsOfService.section6.point1")}</li>
            <li>{t("termsOfService.section6.point2")}</li>
          </ul>
        </section>

        <section>
          <h3 className="mb-2 text-lg font-bold">
            {t("termsOfService.section7.title")}
          </h3>
          <ul className="pl-6 mb-4 list-disc">
            <li>{t("termsOfService.section7.point1")}</li>
            <li>{t("termsOfService.section7.point2")}</li>
          </ul>
        </section>

        <section>
          <h3 className="mb-2 text-lg font-bold">
            {t("termsOfService.section8.title")}
          </h3>
          <ul className="pl-6 mb-4 list-disc">
            <li>{t("termsOfService.section8.point1")}</li>
            <li>{t("termsOfService.section8.point2")}</li>
          </ul>
        </section>

        <section>
          <h3 className="mb-2 text-lg font-bold">
            {t("termsOfService.section9.title")}
          </h3>
          <ul className="pl-6 mb-4 list-disc">
            <li>{t("termsOfService.section9.point1")}</li>
            <li>{t("termsOfService.section9.point2")}</li>
          </ul>
        </section>

        <section>
          <h3 className="mb-2 text-lg font-bold">
            {t("termsOfService.section10.title")}
          </h3>
          <p className="mb-4">{t("termsOfService.section10.description")}</p>
        </section>

        <section>
          <h3 className="mb-2 text-lg font-bold">
            {t("termsOfService.section11.title")}
          </h3>
          <p className="mb-1">{t("termsOfService.section11.intro")}</p>
          <address className="mb-4 not-italic">
            {t("termsOfService.section11.company")}
            <br />
            {t("termsOfService.section11.email")}{" "}
            <a
              href="mailto:privacy@arcology.io"
              className="text-blue-600 hover:underline"
            >
              privacy@arcology.io
            </a>
            <br />
            {t("termsOfService.section11.website")}{" "}
            <a
              href="https://arcology.io"
              className="text-blue-600 hover:underline"
            >
              arcology.io
            </a>
          </address>
        </section>
      </main>
    </article>
  );
}
